import { render, staticRenderFns } from "./order-editshipment.vue?vue&type=template&id=9ca21c4c&"
import script from "./order-editshipment.vue?vue&type=script&lang=ts&"
export * from "./order-editshipment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports